import { newArray } from '@angular/compiler/src/util';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { environment } from '../../environments/environment';
import { PermissionService } from './permission.service';
import { ProfileService } from './profile.service';
import { Storage } from '@ionic/storage';
import { Posthog } from '@capawesome/capacitor-posthog';

@Injectable({
  providedIn: 'root',
})
export class PosthogService {
  trackingAuthorized = true;
  consentCookie: any;
  constructor(
    private profileService: ProfileService,
    private permission: PermissionService,
    private storage: Storage,
  ) {
    if (Capacitor.getPlatform() !== 'ios') {
      this.consentCookie = this.getConsentCookie();
    } else {
      this.trackingStatusIOS();
    }
    this.storage.set('TRACKINGAUTH', this.trackingAuthorized);
  }

  public async init() {
    if (this.trackingAuthorized) {
      const setup = async () => {
        try {
          await Posthog.setup({
            apiKey: environment.posthog_key,
            host: environment.posthog_host
          });
        } catch (error) {
          console.error('Error setting up Posthog:', error);
        }
      };
      await setup();
    }
    this.storage.set('TRACKINGAUTH', this.trackingAuthorized);
  }

  public async pageView(path: string) {
    if (this.trackingAuthorized) {
      await Posthog.capture({
        event: '$pageview',
        properties: {
          $pathname: path
        }
      });
    }
  }

  public reset() {
    if (this.trackingAuthorized) {
      Posthog.reset();
    }
  }

  public async pushIdentify(email: string, id: string, createdAt?: string) {
    if (this.trackingAuthorized) {
      await Posthog.identify({
        distinctId: id,
        userProperties: {
          email: email,
          $lib: Capacitor.getPlatform(),
          cookie_consent: this.consentCookie,
          tracking_consent: this.trackingAuthorized,
          ...(createdAt && { user_created_at: createdAt }),
        }
      });
    }
  }

  public pushEventParams(name: string, props: any) {
    if (this.trackingAuthorized) {
      Posthog.capture({
        event: name,
        properties: props
      });
    }
  }

  public pushEvent(nameEvent: string) {
    if (this.trackingAuthorized) {
      Posthog.capture({ event: nameEvent });
    }
  }

  async trackingStatusIOS() {
    const status = this.permission.getStatus();
    if ((await status).status !== 'authorized') {
      this.trackingAuthorized = false;
    }
    this.storage.set('TRACKINGAUTH', this.trackingAuthorized);
  }

  getConsentCookie() {
    let data;
    if (this.profileService.getCookie('CookieConsent') === null) {
      data = '';
    } else {
      data = this.profileService.getCookie('CookieConsent');
    }

    if (data === '') { return false; }
    const consentCookie = decodeURIComponent(data).replace('{', '').replace('}', '');
    const arrayConsent = consentCookie.split(',');
    let objConsent = [];
    for (let i = 0; i < arrayConsent.length; i++) {
      const infoConsent = arrayConsent[i].split(':');
      const nameConsent = infoConsent[0];
      const valueConsent = infoConsent[1].replace(/'/g, '');
      if ((nameConsent === 'statistics') && (valueConsent === 'false')) {
        this.trackingAuthorized = false;
        this.storage.set('TRACKINGAUTH', this.trackingAuthorized);
      }
      objConsent.push({
        [nameConsent]: valueConsent
      });
    }
    return objConsent;
  }

  async getExperimentVariant(flagName: string) {
    return Posthog.getFeatureFlag({ key: flagName });
  }

}
